import React, { useEffect, useState } from "react";
import SelectReact from "react-select";
import { ApiResponse } from "Types/OSM/Response";

export type SifatOption = {
  value: number;
  label: string;
  name?: string;
};

interface SifatSelectProps {
  value: SifatOption | null;
  onChange: (value: SifatOption | null) => void;
  placeholder?: string;
  initialValueId?: number | null;
}

const SifatSelect = ({
  value,
  onChange,
  placeholder = "Pilih sifat surat...",
  initialValueId,
}: SifatSelectProps) => {
  const [options, setOptions] = useState<SifatOption[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    const fetchSifat = async () => {
      try {
        setLoading(true);
        const res = await fetch("/api/doServices", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            method: "GET",
            endpoint: `office/sifat?page=1&limit=1000`,
            isForm: false,
            isImage: false,
          }),
        });

        if (!res.ok) {
          setLoading(false);
          return;
        }

        const result = (await res.json()) as ApiResponse;
        if (result.http_code !== 200 || !Array.isArray(result.data)) {
          setLoading(false);
          return;
        }

        const opts: SifatOption[] = result.data.map((item: any) => ({
          value: item.id,
          label: item.name ?? "",
          name: item.name,
        }));

        setOptions(opts);

        // Auto-select berdasarkan initialValueId
        if (initialValueId && !value) {
          const foundOption = opts.find(opt => opt.value === initialValueId);
          console.log("SifatSelect auto-select:", {
            initialValueId,
            foundOption,
            currentValue: value,
          });
          if (foundOption) {
            onChange(foundOption);
          }
        }

        setLoading(false);
      } catch (err) {
        console.error("Error fetch sifat:", err);
        setLoading(false);
      }
    };

    fetchSifat();
  }, [initialValueId, onChange, value]);

  return (
    <SelectReact
      isMulti={false}
      isLoading={loading}
      options={options}
      value={value}
      onChange={(val) => onChange(val as SifatOption | null)}
      placeholder={placeholder}
      isClearable
      classNamePrefix="react-select"
    />
  );
};

export default SifatSelect;
